import { FiltersStateT } from 'app/components/FilterPanel/FilterPanel';
import { useMemo } from 'react';
import { useAppSelector } from 'app/store/store';
import { useGetAllValue } from './useGetAllValue';
import { useGetFilterOptionsQuery } from 'app/api/facade';

export const useGetInitialFilterFormValue = (filtersState: FiltersStateT) => {
  const [filters] = filtersState || [];

  const uiConfig = useAppSelector((state) => state.userSlice.uiConfig);

  const { data } = useGetFilterOptionsQuery();

  const allStatuses = useGetAllValue(data?.filter?.status?.values);
  const allSources = useGetAllValue(data?.filter?.source?.values);
  const allTypes = useGetAllValue(data?.filter?.type?.values);
  const allCountries = useGetAllValue(data?.filter?.country?.values);
  const allFleetGroups = useGetAllValue(data?.filter?.fleetGroup?.values);

  const initialFormValue = useMemo(() => {
    if (filters && Object.keys(filters).length > 0) {
      return {
        touched: filters.touched || false,
        formEquality: filters.formEquality || null,
        fleetOnly: filters.fleetOnly || uiConfig?.viewportFleetOnly || false,
        source: filters.source?.map((e) => String(e)) || [],
        type: filters.type?.map((e) => String(e)) || [],
        country: filters.country?.map((e) => String(e)) || [],
        status: filters.status?.map((e) => String(e)) || [],
        fleetGroup: filters.fleetGroup?.map((e) => String(e)) || [],
        statusAll: filters.statusAll,
        typeAll: filters.typeAll,
        countryAll: filters.countryAll,
        sourceAll: filters.sourceAll,
        fleetGroupAll: filters.fleetGroupAll,
        constructionDate_from: filters.constructionDate?.from ? filters.constructionDate.from : undefined,
        constructionDate_to: filters.constructionDate?.to ? filters.constructionDate.to : undefined,
        sog_min: typeof filters.sog?.min === 'number' ? String(filters.sog.min) : undefined,
        sog_max: typeof filters.sog?.max === 'number' ? String(filters.sog.max) : undefined,
        cog_min: typeof filters.cog?.min === 'number' ? String(filters.cog.min) : undefined,
        cog_max: typeof filters.cog?.max === 'number' ? String(filters.cog.max) : undefined,
        heading_min: typeof filters.heading?.min === 'number' ? String(filters.heading.min) : undefined,
        heading_max: typeof filters.heading?.max === 'number' ? String(filters.heading.max) : undefined,

        draught_min: typeof filters.draught?.min === 'number' ? String(filters.draught.min) : undefined,
        draught_max: typeof filters.draught?.max === 'number' ? String(filters.draught.max) : undefined,

        eta_from: filters.eta?.from ? String(filters.eta.from) : undefined,
        eta_to: filters.eta?.to ? String(filters.eta.to) : undefined,
        destinationPortKey: filters.destinationPortKey || [],
        selectedInPort: filters.selectedInPort || undefined,
        selectedDestinationPort: filters.selectedDestinationPort || undefined,

        inPortKey: filters.inPortKey || [],
        selectedInArea: filters.selectedInArea || undefined,
        inAreaCode: filters.inAreaCode || [],
      };
    }
    return {
      touched: false,
      formEquality: null,

      fleetOnly: typeof uiConfig?.viewportFleetOnly === 'boolean' ? uiConfig?.viewportFleetOnly : false,
      source: allSources || [],
      status: allStatuses || [],
      type: allTypes || [],
      country: allCountries || [],
      fleetGroup: allFleetGroups || [],
      statusAll: true,
      typeAll: true,
      countryAll: true,
      sourceAll: true,
      fleetGroupAll: true,
      constructionDate_from: undefined,
      constructionDate_to: undefined,
      eta_from: undefined,
      eta_to: undefined,

      sog_min: undefined,
      sog_max: undefined,
      cog_min: undefined,
      cog_max: undefined,
      heading_min: undefined,
      heading_max: undefined,
      draught_min: undefined,
      draught_max: undefined,
      destinationPortKey: [],
      inPortKey: [],
      selectedInPort: undefined,
      selectedDestinationPort: undefined,

      selectedInArea: undefined,
      inAreaCode: [],
    };
  }, [filters, allCountries, allSources, allTypes, allStatuses, allFleetGroups, uiConfig]);

  return initialFormValue;
};
